"use client"; // Error boundaries must be Client Components

import { Button } from "@mui/material";
import * as Sentry from "@sentry/nextjs";
import ErrorComponent from "common/components/errors/error-page";
import { useEffect } from "react";

export default function Error({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		console.error("Error caught by ErrorBoundary:", error);

		Sentry.captureException(error, {
			tags: {
				component: "error-boundary",
				digest: error.digest,
			},
			contexts: {
				errorBoundary: {
					componentStack: error.stack,
					errorDigest: error.digest,
				},
			},
		});
	}, [error]);

	return (
		<ErrorComponent
			title="Something went wrong"
			message="We encountered an error while loading this page. Please try again."
			buttons={
				<div className="flex-row centered gap-2">
					<Button
						variant="contained"
						onClick={
							// Attempt to recover by trying to re-render the segment
							() => reset()
						}
					>
						Try again
					</Button>
					<Button variant="outlined" onClick={() => window.history.back()}>
						Go Back
					</Button>
				</div>
			}
		/>
	);
}
